import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { RecoilRoot } from 'recoil';
import { ThemeProvider } from 'styled-components';

import { apollo } from '../../graphql-client';
import { ProviderRedux } from '../../reduxstore/provider';
import { Loader } from '../Loader';
import { web } from '../../themes';

export const Providers = ({
	children
}: {
	children: React.ReactNode;
}): JSX.Element => (
	<ProviderRedux>
		<RecoilRoot>
			<ApolloProvider client={apollo}>
				<ThemeProvider theme={web}>
					<Loader title="Providers">
						<Router>{children}</Router>
					</Loader>
				</ThemeProvider>
			</ApolloProvider>
		</RecoilRoot>
	</ProviderRedux>
);
